export const STRINGS = {
  pt: {
    nav: {
      formats: "Formatos",
      levels: "Níveis",
      styles: "Estilos",
      professor: "O Professor",
      book: "Agendar",
      contact: "Contato",
      studentArea: "Área do Aluno",
      logout: "Sair",
    },
    hero: {
      overline: "Improvisational Guitar Lab",
      lines: ["A arte do", "improviso", "começa aqui."],
      subtitle:
        "Aulas particulares, aulas online, workshops e masterclasses para quem quer ir além das tablaturas. Do iniciante ao avançado — rock, blues, jazz e fusion — com método, repertório e a liberdade de encontrar a sua voz no instrumento.",
      ctaBook: "Agendar aula experimental",
      ctaExplore: "Explorar formatos",
      stats: [
        ["25+", "anos de estrada"],
        ["500+", "alunos formados"],
        ["04", "formatos de estudo"],
      ],
    },
    formatsSection: {
      overline: "Formatos",
      title: ["Quatro portas de entrada, ", "um só destino"],
      copy: "Presencial ou online, individual ou em grupo: cada formato foi desenhado para um momento diferente da sua jornada — todos apontando para o improviso.",
      bookCta: "Agendar neste formato",
    },
    levelsSection: {
      overline: "Níveis",
      title: ["Um percurso, ", "três alturas"],
      resultLabel: "Resultado",
    },
    stylesSection: {
      overline: "Estilos",
      title: ["Quatro dialectos, ", "uma gramática"],
      copy: "Cada estilo é um território com sotaque próprio. Você escolhe por onde começar — a linguagem do improviso atravessa todos.",
    },
    about: {
      overline: "O Professor",
      title: ["Quem é ", "Ricardo Oliveira", "?"],
      lead: "Músico profissional, guitarrista, professor e produtor de conteúdo, natural de São Paulo, com mais de 25 anos dedicados à música. Sua identidade foi construída entre estudos, palcos, igrejas, estúdios, gravações e ensino — sempre buscando compreender o papel da guitarra dentro de cada contexto.",
      quote: "Mais de duas décadas vivendo música.",
      portraitCaption: "Ricardo Oliveira — guitarrista & professor",
      milestones: [
        {
          title: "Do violão à guitarra",
          text: "Começou aos 15 anos no violão. Aos 18, encontrou na guitarra elétrica a grande paixão e o foco da carreira.",
        },
        {
          title: "EM&T / IG&T — São Paulo",
          text: "Formação na Escola de Música e Tecnologia, ligada ao Instituto de Guitarra e Tecnologia, com contato direto com grandes nomes como Edu Ardanuy.",
        },
        {
          title: "Palcos & estúdios",
          text: "Experiência construída na prática: ensaios, apresentações ao vivo, acompanhamentos e gravações em diferentes projetos musicais.",
        },
        {
          title: "Berklee & Estados Unidos",
          text: "Um semestre de Jazz Improvisation na Berklee College of Music, em Boston. Hoje vive nos EUA, onde trabalha com música em uma igreja americana — e segue ensinando, gravando e criando conteúdo.",
        },
      ],
      artistsLabel: "Projetos & acompanhamentos com artistas da música cristã contemporânea",
      igtLabel: "IG&T — com Edu Ardanuy",
      igtAlt: "Ricardo Oliveira na época do IG&T",
      gallery: [
        ["/about-palcos.jpg", "Ao vivo — palcos e apresentações"],
        ["/about-estudio.jpg", "No estúdio — gravações e produção"],
        ["/about-atual.jpg", "Nova fase — Estados Unidos"],
        ["/about-igt.jpg", "Formação — EM&T / IG&T"],
      ],
    },
    booking: {
      overline: "Agendamento",
      title: ["Reserve sua ", "aula experimental"],
      copy: "Escolha formato, nível, estilo e horário. Confirmamos por e-mail e preparamos a sessão para o seu momento — sem compromisso, sem enrolação.",
      notes: ["Seg — Sáb · 09h às 21h", "Confirmação por e-mail em até 2h", "Remarcação gratuita até 12h antes"],
      name: "Nome",
      namePh: "Seu nome",
      email: "E-mail",
      emailPh: "voce@email.com",
      phone: "Telefone (opcional)",
      phonePh: "(11) 90000-0000",
      format: "Formato",
      level: "Nível",
      style: "Estilo",
      date: "Data",
      time: "Horário",
      slotsHint: "Escolha uma data para ver os horários disponíveis",
      slotsLoading: "Verificando agenda...",
      notesLabel: "Observações (opcional)",
      notesPh: "Há quanto tempo toca? O que quer destravar?",
      submit: "Confirmar agendamento",
      submitting: "Reservando...",
      pickTime: "Escolha um horário para continuar.",
      confirmationTitle: "Aula reservada",
      confirmationEmail: "Enviamos os detalhes para",
      payTitle: "Garanta sua vaga pagando agora",
      createAccount: "Criar conta para acompanhar",
      bookAnother: "Fazer outro agendamento",
    },
    contact: {
      overline: "Contato",
      title: ["Ainda com dúvida? ", "Chama no estúdio"],
      name: "Nome",
      namePh: "Seu nome",
      email: "E-mail",
      emailPh: "voce@email.com",
      message: "Mensagem",
      messagePh: "Conte onde você está na guitarra e onde quer chegar",
      submit: "Enviar mensagem",
      submitting: "Enviando...",
      success: "Mensagem enviada. Respondemos em até um dia útil.",
      hours: "Seg — Sáb · 09h às 21h",
    },
    footer: {
      tagline: "Improvisational Guitar Lab — desde 2016",
      rights: "IGL — Improvisational Guitar Lab. Todos os direitos reservados.",
      made: "Feito com cordas, válvulas e silêncio",
    },
    auth: {
      title: "Área do Aluno",
      subtitle: "Entre para acompanhar seus agendamentos e materiais de estudo.",
      tabLogin: "Entrar",
      tabRegister: "Criar conta",
      emailPh: "E-mail",
      passwordPh: "Senha",
      namePh: "Nome completo",
      passwordNewPh: "Senha (mín. 6 caracteres)",
      loginBtn: "Entrar",
      registerBtn: "Criar conta",
      welcomeBack: "Bem-vindo de volta ao estúdio.",
      accountCreated: "Conta criada. Bem-vindo ao IGL.",
    },
    portal: {
      overline: "Área do Aluno",
      hello: "Olá,",
      nextLesson: "Próxima aula:",
      lockedTitle: "Entre para continuar",
      lockedCopy: "Seus agendamentos, pacotes e materiais de estudo ficam guardados aqui.",
      lockedCta: "Entrar ou criar conta",
      logout: "Sair",
      bookingsTitle: "Seus agendamentos",
      newBooking: "+ Novo agendamento",
      emptyBookings: "Nenhum agendamento ainda. Que tal reservar sua aula experimental?",
      bookNow: "Agendar agora",
      cancel: "Cancelar aula",
      cancelled: "Agendamento cancelado.",
      statusMap: { confirmado: "confirmado", cancelado: "cancelado" },
      planTitle: "Plano mensal",
      planCopy: "Aulas toda semana com valor fechado. Pagamento seguro via PayPal, em dólar.",
      planPerks: "aulas por mês · qualquer formato",
      perMonth: "por mês",
      planName: { "mensal-4": "Plano Mensal — 4 aulas" },
      materialsTitle: "Materiais da semana",
      materials: [
        { title: "Backing track — Blues em Lá", meta: "12 compassos · 90 BPM · Pentatônica Am" },
        { title: "Backing track — ii–V–I em Sol", meta: "Swing · 120 BPM · Arpejos estendidos" },
        { title: "Guia — Os 5 desenhos da pentatônica", meta: "PDF · Nível intermediário" },
        { title: "Rotina de estudo — 30 min/dia", meta: "Técnica · Repertório · Improviso" },
      ],
      payNote: "Você será redirecionado ao PayPal para pagar com segurança. O recibo chega por e-mail.",
      payBtn: "Pagar com PayPal",
      payNotConfigured: "Pagamento online em configuração — você também pode pagar no dia da aula",
    },
  },
  en: {
    nav: {
      formats: "Formats",
      levels: "Levels",
      styles: "Styles",
      professor: "The Teacher",
      book: "Book",
      contact: "Contact",
      studentArea: "Student Area",
      logout: "Log out",
    },
    hero: {
      overline: "Improvisational Guitar Lab",
      lines: ["The art of", "improv", "starts here."],
      subtitle:
        "Private lessons, online lessons, workshops and masterclasses for players who want to go beyond tabs. From beginner to advanced — rock, blues, jazz and fusion — with method, repertoire and the freedom to find your own voice on the instrument.",
      ctaBook: "Book a trial lesson",
      ctaExplore: "Explore formats",
      stats: [
        ["25+", "years on the road"],
        ["500+", "students taught"],
        ["04", "study formats"],
      ],
    },
    formatsSection: {
      overline: "Formats",
      title: ["Four doors in, ", "one destination"],
      copy: "In person or online, one-on-one or in a group: each format was designed for a different moment of your journey — all of them pointing toward improvisation.",
      bookCta: "Book this format",
    },
    levelsSection: {
      overline: "Levels",
      title: ["One journey, ", "three heights"],
      resultLabel: "Outcome",
    },
    stylesSection: {
      overline: "Styles",
      title: ["Four dialects, ", "one grammar"],
      copy: "Each style is a territory with its own accent. You choose where to start — the language of improvisation crosses them all.",
    },
    about: {
      overline: "The Teacher",
      title: ["Who is ", "Ricardo Oliveira", "?"],
      lead: "Professional musician, guitarist, teacher and content producer from São Paulo, Brazil, with over 25 years dedicated to music. His identity was built across studies, stages, churches, studios, recordings and teaching — always seeking to understand the role of the guitar in each context.",
      quote: "More than two decades living music.",
      portraitCaption: "Ricardo Oliveira — guitarist & teacher",
      milestones: [
        {
          title: "From acoustic to electric",
          text: "He started on acoustic guitar at 15. At 18, the electric guitar became his great passion and the focus of his career.",
        },
        {
          title: "EM&T / IG&T — São Paulo",
          text: "Training at the School of Music and Technology, linked to the Guitar and Technology Institute, with direct contact with great names such as Edu Ardanuy.",
        },
        {
          title: "Stages & studios",
          text: "Experience built in practice: rehearsals, live performances, sideman work and recordings across many musical projects.",
        },
        {
          title: "Berklee & the United States",
          text: "A semester of Jazz Improvisation at Berklee College of Music in Boston. He now lives in the US, working with music at an American church — while still teaching, recording and creating content.",
        },
      ],
      artistsLabel: "Projects & performances with contemporary Christian music artists",
      igtLabel: "IG&T — with Edu Ardanuy",
      igtAlt: "Ricardo Oliveira during his IG&T years",
      gallery: [
        ["/about-palcos.jpg", "Live — stages and performances"],
        ["/about-estudio.jpg", "In the studio — recording and production"],
        ["/about-atual.jpg", "New chapter — United States"],
        ["/about-igt.jpg", "Training — EM&T / IG&T"],
      ],
    },
    booking: {
      overline: "Booking",
      title: ["Book your ", "trial lesson"],
      copy: "Choose format, level, style and time. We confirm by email and prepare the session for your moment — no strings attached.",
      notes: ["Mon — Sat · 9am to 9pm", "Email confirmation within 2h", "Free rescheduling up to 12h before"],
      name: "Name",
      namePh: "Your name",
      email: "Email",
      emailPh: "you@email.com",
      phone: "Phone (optional)",
      phonePh: "+1 555 000 0000",
      format: "Format",
      level: "Level",
      style: "Style",
      date: "Date",
      time: "Time",
      slotsHint: "Pick a date to see available times",
      slotsLoading: "Checking schedule...",
      notesLabel: "Notes (optional)",
      notesPh: "How long have you been playing? What do you want to unlock?",
      submit: "Confirm booking",
      submitting: "Booking...",
      pickTime: "Pick a time slot to continue.",
      confirmationTitle: "Lesson booked",
      confirmationEmail: "We sent the details to",
      payTitle: "Secure your spot — pay now",
      createAccount: "Create an account to keep track",
      bookAnother: "Book another lesson",
    },
    contact: {
      overline: "Contact",
      title: ["Still have questions? ", "Reach out to the studio"],
      name: "Name",
      namePh: "Your name",
      email: "Email",
      emailPh: "you@email.com",
      message: "Message",
      messagePh: "Tell us where you are on guitar and where you want to go",
      submit: "Send message",
      submitting: "Sending...",
      success: "Message sent. We reply within one business day.",
      hours: "Mon — Sat · 9am to 9pm",
    },
    footer: {
      tagline: "Improvisational Guitar Lab — since 2016",
      rights: "IGL — Improvisational Guitar Lab. All rights reserved.",
      made: "Made with strings, tubes and silence",
    },
    auth: {
      title: "Student Area",
      subtitle: "Sign in to track your bookings and study materials.",
      tabLogin: "Sign in",
      tabRegister: "Create account",
      emailPh: "Email",
      passwordPh: "Password",
      namePh: "Full name",
      passwordNewPh: "Password (min. 6 chars)",
      loginBtn: "Sign in",
      registerBtn: "Create account",
      welcomeBack: "Welcome back to the studio.",
      accountCreated: "Account created. Welcome to IGL.",
    },
    portal: {
      overline: "Student Area",
      hello: "Hello,",
      nextLesson: "Next lesson:",
      lockedTitle: "Sign in to continue",
      lockedCopy: "Your bookings, packages and study materials live here.",
      lockedCta: "Sign in or create account",
      logout: "Log out",
      bookingsTitle: "Your bookings",
      newBooking: "+ New booking",
      emptyBookings: "No bookings yet. How about booking your trial lesson?",
      bookNow: "Book now",
      cancel: "Cancel lesson",
      cancelled: "Booking cancelled.",
      statusMap: { confirmado: "confirmed", cancelado: "cancelled" },
      planTitle: "Monthly plan",
      planCopy: "Weekly lessons at a fixed price. Secure PayPal payment, in USD.",
      planPerks: "lessons per month · any format",
      perMonth: "per month",
      planName: { "mensal-4": "Monthly Plan — 4 lessons" },
      materialsTitle: "This week's materials",
      materials: [
        { title: "Backing track — Blues in A", meta: "12 bars · 90 BPM · A minor pentatonic" },
        { title: "Backing track — ii–V–I in G", meta: "Swing · 120 BPM · Extended arpeggios" },
        { title: "Guide — The 5 pentatonic shapes", meta: "PDF · Intermediate level" },
        { title: "Practice routine — 30 min/day", meta: "Technique · Repertoire · Improvisation" },
      ],
      payNote: "You will be redirected to PayPal to pay securely. The receipt arrives by email.",
      payBtn: "Pay with PayPal",
      payNotConfigured: "Online payment being set up — you can also pay on the day of the lesson",
    },
  },
};
